<template>
  <section class="hero has-bg-img is-light is-fullheight-with-navbar">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <!--<h1 class="title">
            {{ $translate("project_name") }} ver. {{ $translate("version") }}
          </h1>
          <h2 class="subtitle">{{ $translate("welcome") }}</h2>-->
          <div class="column is-four-fifths">
            <img
              src="../assets/images/HOME_GIF.gif"
              alt="Footura"
            >
          </div>
          <div class="column is-vertical-center">
            <ul class="is-pulled-right">
              <li>
                <b-tooltip
                  :label="$translate('new_patient') | capitalize"
                  type="is-dark"
                  square
                >
                  <router-link
                    to="/patients/new"
                    class="navbar-item"
                  >
                    <b-icon
                      type="is-primary"
                      icon="account-plus-outline"
                      size="is-large"
                    />
                  </router-link>
                </b-tooltip>
              </li>
              <li>
                <b-tooltip
                  :label="$translate('search_patient') | capitalize"
                  type="is-dark"
                  square
                >
                  <router-link
                    to="/patients"
                    class="navbar-item"
                  >
                    <b-icon
                      type="is-primary"
                      icon="account-search-outline"
                      size="is-large"
                    />
                  </router-link>
                </b-tooltip>
              </li>
              <li>
                <b-tooltip
                  :label="$translate('search_order') | capitalize"
                  type="is-dark"
                  square
                >
                  <router-link
                    to="/orders"
                    class="navbar-item"
                  >
                    <b-icon
                      type="is-primary"
                      icon="email-search-outline"
                      size="is-large"
                    />
                  </router-link>
                </b-tooltip>
              </li>
              <li>
                <b-tooltip
                  :label="$translate('model_catalog') | capitalize"
                  type="is-dark"
                  square
                >
                  <router-link
                    to="/catalogs"
                    class="navbar-item"
                  >
                    <b-icon
                      type="is-primary"
                      icon="format-list-bulleted"
                      size="is-large"
                    />
                  </router-link>
                </b-tooltip>
              </li>
              <!--<li>
                <b-tooltip label="Listino prezzi" type="is-dark" square>
                  <router-link to="/companies" class="navbar-item">
                    <b-icon icon="currency-usd" size="is-large"></b-icon>
                  </router-link>
                </b-tooltip>
              </li>-->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style lang="scss" scoped>
.navbar-item:hover {
  color: white;
}
.is-vertical-center {
  display: flex;
  align-items: center;
}
.has-bg-img {
  background: url("../assets/images/HOME_Footuta.png") center center;
  background-size: cover;
}
</style>>
